import { Box } from '@mui/material';
import OutlinedInputComponent from '../../common/widgets/outlined-input';
import { useState } from 'react';
import { ToolsAndTechnologyFilters } from '../type';

interface ToolsAndTechnologiesFilterProps {
  onFilterChange: (
    toolsAndTechnologyFilters: ToolsAndTechnologyFilters
  ) => void;
}

const ToolsAndTechnologiesFilter = ({
  onFilterChange
}: ToolsAndTechnologiesFilterProps): JSX.Element => {
  const [toolsAndTechnologyFilters, setFilters] =
    useState<ToolsAndTechnologyFilters>({ name: '' });

  const handleNameChange = (value: string): void => {
    const updatedToolsAndTechnologyFilters = {
      ...toolsAndTechnologyFilters,
      name: value
    };
    setFilters(updatedToolsAndTechnologyFilters);
    onFilterChange(updatedToolsAndTechnologyFilters);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        marginRight: '20px'
      }}
    >
      <OutlinedInputComponent
        onChangeCallback={handleNameChange}
        placeholder="Search"
        height="48px"
        width="100%"
        borderRadius="8px"
        fontSize="16px"
        fontWeight="500"
        color="#5F6368"
      />
    </Box>
  );
};

export default ToolsAndTechnologiesFilter;
